import React from 'react';
import { CostItem } from '../CostItem';
export const EstimatedFees = ({ value }) => {
    return React.createElement(CostItem, { name: "Estimated payment processing fees", value: value, negative: true });
};
